module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAA80lEQVRoQ+2auw7DIBAEcx8NbZwWPpqIIhIpIt9jTyho3frYMzMUYCG11muM8XwEHhF5tdYuSwSqr5RShqXxr9reu1hyUH0hE9hlYAL7moCVooU4sna1xwkgyWqzaEBLKquOBrLIanNpQEsqq44Gsshqc2lASyqr7iwDn4OFZ0ucRfgud/1m0yHkLnjHe05gB/W1Jw3QQJAAl1AQYHg4DYQRBgNoIAgwPFz+fjO37q35bzS8IHQBZx1ouIR01qFVXEJQnI4wGnBAgw6hAShORxgNOKBBh5xrwIvJ818Vcdljfi/krsQMsm7FYZc9ECR2GZh93ym8C4g0o+v1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/community/full-screen.png
// module id = 2r6I
// module chunks = 16